/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Btn_ContinueInputs */

const es_ab_btn_continue = /** @type {(inputs: Ab_Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar y verificar email`)
};

const gl_ab_btn_continue = /** @type {(inputs: Ab_Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar e verificar email`)
};

const en_ab_btn_continue = /** @type {(inputs: Ab_Btn_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue and verify email`)
};

/**
* | output |
* | --- |
* | "Continue and verify email" |
*
* @param {Ab_Btn_ContinueInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_btn_continue = /** @type {((inputs?: Ab_Btn_ContinueInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Btn_ContinueInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_btn_continue(inputs)
	if (locale === "en") return en_ab_btn_continue(inputs)
	return es_ab_btn_continue(inputs)
});